export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13336.2063ba5e.jpg";